export const OKTA_API_URL = import.meta.env.VITE_OKTA_API_URL;
export const API_URL = import.meta.env.VITE_API_URL;
export const TIMEOUT_SECS = 10 * 1000;
